module.exports = __webpack_public_path__ + "img/basurero.74e46c2c.svg";